import { render, staticRenderFns } from "./Accepted.vue?vue&type=template&id=6dee0c65&"
import script from "./Accepted.vue?vue&type=script&lang=js&"
export * from "./Accepted.vue?vue&type=script&lang=js&"
import style0 from "./Accepted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Accepted.vue"
export default component.exports